import React, { FC } from 'react';
import ClipBoard from 'react-copy-to-clipboard';

import { useSnackBar } from '../SnackBar';


type Props = {
    url: string;
    size?: number;
};


export const Clip: FC<Props> = ({ url, size }) => {
    const { openSnackBar } = useSnackBar();

    return (
        <ClipBoard text={url} onCopy={() => openSnackBar('クリップボードにコピーしました。')}>
            <button>
                <img
                    width={`${size ? size : 56}px`}
                    height={`${size ? size : 56}px`}
                    src={`${process.env.PUBLIC_URL}/img/icon_copy.png`}
                />

                <style jsx>{`
                    button {
                        cursor: pointer;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: ${size ? size : 56}px;
                        height: ${size ? size : 56}px;
                        border-radius: 50%;
                        border: none;
                        padding: 0;
                        background: #fff;
                    }
                `}</style>
            </button>
        </ClipBoard>
    );
};
